module.exports = __webpack_public_path__ + "media/images/download-3aba876f363aa661aa80472fef5147a4.svg";